import { useState } from "react";

function todayString(): string {
  const now = new Date();
  return now.toISOString().slice(0, 10);
}

export function CsvExport() {
  const [from, setFrom] = useState(todayString());
  const [to, setTo] = useState(todayString());
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setError(null);
    try {
      const response = await fetch(`/api/csv/orders?from=${from}&to=${to}`, { credentials: "include" });
      if (!response.ok) {
        const body = (await response.json()) as { error?: string };
        throw new Error(body.error ?? "CSVの生成に失敗しました");
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `sales_${from}_${to}.csv`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : "CSVの生成に失敗しました");
    }
  };

  return (
    <div className="stack">
      <h2>CSV出力</h2>
      <p style={{ color: "var(--color-text-muted)" }}>
        指定期間の売上をUTF-8 BOM付きCSVで出力します（Excel・Googleスプレッドシートで文字化けしにくい形式です）。
      </p>
      <div className="card row row-wrap">
        <div className="form-field">
          <label htmlFor="csv-from">開始日</label>
          <input id="csv-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div className="form-field">
          <label htmlFor="csv-to">終了日</label>
          <input id="csv-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-lg" onClick={() => void handleDownload()}>
          CSVダウンロード
        </button>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
    </div>
  );
}
